export enum PermissionActionEnum {
    View = "view",
    Add = "add",
    Edit = "edit",
    Delete = "delete",
    Reassign = "reassign",
    ExportAnsi = "export ansi",
    ESubmission = "e-submission",
    ExportReport = "export",
    ManualSubmission = "manual submission"
}
